import { Component, KeyboardEvent, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolModal, PoolTextArea } from '@synergy/components';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

import { Inquiry } from '../../models/inquiry';

const styles = () =>
    createStyles({
        buttons: {
            minWidth: 199,
            textTransform: 'uppercase',
        },
    });

interface OffersDeclineModalProps extends WithStyles<typeof styles> {
    open: boolean;
    cancel: () => void;
    decline: (comment: string) => void;
    inquiry?: Inquiry;
}

interface OffersDeclineModalState {
    comment: string;
    error?: ReactNode;
}

class OffersDeclineModalBase extends Component<OffersDeclineModalProps, OffersDeclineModalState> {
    public override state: OffersDeclineModalState = {
        comment: '',
    };

    private handleSubmit = () => {
        const comment = this.state.comment.trim();
        if (!comment) {
            this.setState({ error: <FormattedMessage id={'app.common.errors.required'} /> });
        } else {
            this.props.decline(comment);
        }
    };

    private handleKeyPress = (event: KeyboardEvent) => {
        if (event.ctrlKey && event.key === 'Enter') {
            this.handleSubmit();
        }
    };

    public override render() {
        const { classes, inquiry, open, cancel } = this.props;
        const { comment, error } = this.state;

        const declineActionChildren = [
            <PoolButton key="2" variant="text" styleType="firstLevel" onClick={cancel} className={classes.buttons}>
                <FormattedMessage id="app.common.cancel" />
            </PoolButton>,
            <PoolButton
                key="1"
                styleType="firstLevel"
                onClick={this.handleSubmit}
                disabled={comment === ''}
                className={classes.buttons}
            >
                <FormattedMessage id={inquiry?.isAuction ? 'app.offers.declineAuction' : 'app.offers.decline'} />
            </PoolButton>,
        ];

        return (
            <PoolModal
                actionChildren={declineActionChildren}
                handleClose={cancel}
                isVisible={open}
                title={
                    <FormattedMessage
                        id={inquiry?.isAuction ? 'app.offers.declineAuction' : 'app.offers.declineWarning'}
                    />
                }
            >
                <PoolTextArea
                    id="inquiry-decline-textfield"
                    label={<FormattedMessage id="app.label.reason" />}
                    value={comment}
                    onChange={event => this.setState({ comment: event.currentTarget.value })}
                    required={true}
                    error={!!error}
                    helperText={error}
                    rows="4"
                    rowsMax="10"
                    onKeyPress={this.handleKeyPress}
                />
            </PoolModal>
        );
    }
}

export const OffersDeclineModal = withStyles(styles)(OffersDeclineModalBase);
